import React from 'react'

export interface BreadcrumbProps {
  breadcrumbs: Breadcrumb[]
}

export interface Breadcrumb {
  link: string
  name: string
  image?: string
}

const GoogleStructuredDataBreadcrumb = ({ breadcrumbs }: BreadcrumbProps) => {
  const articleBreadcrumbStructuredData = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': breadcrumb.link,
        name: breadcrumb.name,
        image: breadcrumb.image || ''
      }
    }))
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(articleBreadcrumbStructuredData)
      }}
    />
  )
}

export default GoogleStructuredDataBreadcrumb
